import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type OnboardingSurveyCompleted } from '../types';
import META from './useTrackCompletedOnboardingSource.meta';

export const useTrackCompletedOnboardingSource = () => {
  const { track } = useAnalyticsUtilities();

  const trackCompletedOnboardingSource = useCallback(
    (params: OnboardingSurveyCompleted) => {
      track(META.name, params, { integrations: { Intercom: true } });
    },
    [track],
  );

  return { trackCompletedOnboardingSource };
};
